import { render, staticRenderFns } from "./ForgotPasswordOtp.vue?vue&type=template&id=04aadca4&scoped=true&"
import script from "./ForgotPasswordOtp.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordOtp.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordOtp.vue?vue&type=style&index=0&id=04aadca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aadca4",
  null
  
)

export default component.exports